import React from "react";
import { useState } from "react";
import helperNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";

export default function ReportPositionsReserver() {
  const [reportPosition, setReportPosition] = useState(null);
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getReportPosition = async (e) => {
    e.preventDefault();
    let tagHtmlID = document.querySelector("#html-tag-id").value;
    if (!tagHtmlID.includes("hilite-position-")) {
      setMessage({
        type_class: "alert alert-danger",
        text: "تگ   id  html جایگاه نامعتبر است.  ",
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    const tagHtmlIDNumber = tagHtmlID.replace("hilite-position-", "");
    if (!Number.isInteger(parseInt(tagHtmlIDNumber))) {
      setMessage({
        type_class: "alert alert-danger",
        text: "تگ   id  html جایگاه نامعتبر است.  ",
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }

    setReportPosition({
      active: [{ end_date: "2022/10/30", start_date: "2022/10/25" }],
      pending: [{ end_date: "2022/11/10", start_date: "2022/11/02" }],
      website_url: "https://senfnews.com",
      size: "970-90",
      count: "3",
    });
  };

  const generateReportPositionCampaignActive = () => {
    let campaignIDSActive = reportPosition.active;
    return (
      <>
        <hr />
        <h4 className="text text-danger">
          کمپین های در حالت فعال برای این جایگاه
        </h4>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space  mb-2">
            <thead>
              <tr>
                <td>#</td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
              </tr>
            </thead>
            <tbody>
              {campaignIDSActive.map((item, index) => {
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td className="number-finance" dir="ltr">
                      {helperNumbers.toPersianNum(
                        helpersTime.convertGregorianToJalali(item.start_date) +
                          " 00:00"
                      )}
                    </td>
                    <td className="number-finance" dir="ltr">
                      {helperNumbers.toPersianNum(
                        helpersTime.convertGregorianToJalali(item.end_date) +
                          " 23:59"
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <hr />
      </>
    );
  };

  const generateReportPositionCampaignPending = () => {
    let campaignIDSPending = reportPosition.pending;
    return (
      <>
        <hr />
        <h4 className="text text-warning">
          کمپین های در حال انتظار برای این جایگاه
        </h4>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space  mb-2">
            <thead>
              <tr>
                <td>#</td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
              </tr>
            </thead>
            <tbody>
              {campaignIDSPending.map((item, index) => {
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td className="number-finance" dir="ltr">
                      {helperNumbers.toPersianNum(
                        helpersTime.convertGregorianToJalali(item.start_date) +
                          " 00:00"
                      )}
                    </td>
                    <td className="number-finance" dir="ltr">
                      {helperNumbers.toPersianNum(
                        helpersTime.convertGregorianToJalali(item.end_date) +
                          " 23:59"
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <hr />
      </>
    );
  };

  return (
    <>
      <div
        className="tab-pane fade border border-3 p-2 rounded"
        id="group-report-positions"
        role="tabpanel"
        aria-labelledby="group-publisher-tab"
      >
        {messageTag}
        <form onSubmit={getReportPosition} action="">
          <div>
            <p className="text-justify">
              جهت مشاهده وضعیت رزرواسیون جایگاه مدنظر id تگ html جایگاه وارد
              کنید.
            </p>
          </div>
          <div className="input-group pt-3 mb-3">
            <input
              type="text"
              id="html-tag-id"
              className="form-control"
              placeholder="hilite-position-"
              required
            />
            <div className="input-group-append">
              <button className="btn btn-success" type="submit">
                نمایش رزور جایگاه
              </button>
            </div>
          </div>
        </form>
        {reportPosition !== null ? (
          <>
            {reportPosition.active.length !== 0 ? (
              generateReportPositionCampaignActive()
            ) : (
              <p className="alert alert-primary">
                این جایگاه فعلا هیچ کمپین در حالت فعال ندارد
              </p>
            )}
          </>
        ) : (
          <></>
        )}

        {reportPosition !== null ? (
          <>
            {reportPosition.pending.length !== 0 ? (
              generateReportPositionCampaignPending()
            ) : (
              <p className="alert alert-primary">
                این جایگاه فعلا هیچ کمپین در حال انتظار ندارد
              </p>
            )}
          </>
        ) : (
          <></>
        )}

        {reportPosition !== null ? (
          <div className="table-responsive">
            <table className="table table-hilite tbl-td-white-space ">
              <thead>
                <tr>
                  <td
                    colSpan={2}
                    className="text-center"
                    style={{ borderRadius: "25px 25px 0 0" }}
                  >
                    <b>اطلاعات جایگاه</b>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>آدرس صفحه</td>
                  <td dir="ltr" className="text-left ">
                    <span className="pr-2">{reportPosition.website_url}</span>
                    <a
                      target="_blank"
                      className="btn btn-primary"
                      href={reportPosition.website_url}
                    >
                      <i className="fa fa-link"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>اندازه</td>
                  <td>
                    <span>ارتفاع = </span>
                    <span>
                      {helperNumbers.toPersianNum(
                        reportPosition.size.split("-")[1]
                      )}
                    </span>
                    <span className="px-3">عرض = </span>
                    <span>
                      {helperNumbers.toPersianNum(
                        reportPosition.size.split("-")[0]
                      )}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>تعداد بنر</td>
                  <td>{helperNumbers.toPersianNum(reportPosition.count)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
